import React from "react";
import Flagship from "../../core/flagship";
import PropTypes from "prop-types";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import "../../styles/commentBox.scss";
import "tributejs/scss/tribute.scss";
import moment from "moment-business-days";
import "moment-timezone";
import Linkify from "react-linkify";
import {
  getFormattedValue,
  getTimezone,
  stripHTML,
  addMentions,
} from "../../utils/helpers";
import Tribute from "tributejs";
import UserCircle from "./UserCircle";
import UserField from "./UserField";
import ContentEditable from "react-contenteditable";
import {
  Divider,
  Feed,
  Form,
  Table,
  Loader,
  Header,
  Button,
  Label,
  Icon,
  Input,
  Image,
} from "semantic-ui-react";

(function (cursorManager) {
  //From: http://www.w3.org/TR/html-markup/syntax.html#syntax-elements
  var voidNodeTags = [
    "SPAN",
    "AREA",
    "BASE",
    "BR",
    "COL",
    "EMBED",
    "HR",
    "IMG",
    "INPUT",
    "KEYGEN",
    "LINK",
    "MENUITEM",
    "META",
    "PARAM",
    "SOURCE",
    "TRACK",
    "WBR",
    "BASEFONT",
    "BGSOUND",
    "FRAME",
    "ISINDEX",
  ];

  //From: https://stackoverflow.com/questions/237104/array-containsobj-in-javascript
  Array.prototype.contains = function (obj) {
    let i = this.length;
    while (i--) {
      if (this[i] === obj) {
        return true;
      }
    }
    return false;
  };

  //Basic idea from: https://stackoverflow.com/questions/19790442/test-if-an-element-can-contain-text
  function canContainText(node) {
    if (node.nodeType === 1) {
      //is an element node
      return !voidNodeTags.contains(node.nodeName);
    } else {
      //is not an element node
      return false;
    }
  }

  function getLastChildElement(el) {
    let lc = el.lastChild;
    while (lc && lc.nodeType !== 1) {
      if (lc.previousSibling) lc = lc.previousSibling;
      else break;
    }
    return lc;
  }

  //Based on Nico Burns's answer
  cursorManager.setEndOfContenteditable = function (contentEditableElement) {
    while (
      getLastChildElement(contentEditableElement) &&
      canContainText(getLastChildElement(contentEditableElement))
    ) {
      contentEditableElement = getLastChildElement(contentEditableElement);
    }

    let range, selection;
    if (document.createRange) {
      //Firefox, Chrome, Opera, Safari, IE 9+
      range = document.createRange(); //Create a range (a range is a like the selection but invisible)
      range.selectNodeContents(contentEditableElement); //Select the entire contents of the element with the range
      range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
      selection = window.getSelection(); //get the selection object (allows you to change selection)
      selection.removeAllRanges(); //remove any selections already made
      selection.addRange(range); //make the range you have just created the visible selection
    } else if (document.selection) {
      //IE 8 and lower
      range = document.body.createTextRange(); //Create a range (a range is a like the selection but invisible)
      range.moveToElementText(contentEditableElement); //Select the entire contents of the element with the range
      range.collapse(false); //collapse the range to the end point. false means collapse to end rather than the start
      range.select(); //Select the range (make it the visible selection
    }
  };
})((window.cursorManager = window.cursorManager || {}));

class CommentBox extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.commentKeyDown = this.commentKeyDown.bind(this);
    this.commentChange = this.commentChange.bind(this);
    this.addComment = this.addComment.bind(this);
    this.getComments = this.getComments.bind(this);
    this.resetCommentBox = this.resetCommentBox.bind(this);
    this.updateMentions = this.updateMentions.bind(this);
    this.getActiveUsers = this.getActiveUsers.bind(this);
    this.highlightSearch = this.highlightSearch.bind(this);
  }

  getInitialState() {
    return {
      loading: true,
      commentValue: "",
      commentsShown: this.props.viewMode === "full" ? 99999 : 5,
      searching: this.props.search === true,
      comments: [],
      mentioned: [],
    };
  }

  componentDidMount() {
    this.getComments();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.recordId !== this.props.recordId) {
      this.getComments();
    }
    if (prevProps.search !== this.props.search) {
      if (this.inputRef) {
        this.inputRef.focus();
      }

      this.props.onCommentFilterSearchChange(false);
      this.props.onCommentFilterUserChange(false);
    }
  }

  commentKeyDown(e) {
    if (e.key === "Enter" && e.location === 3) {
      let elements = Array.from(
        document.querySelectorAll(".tribute-container")
      ).filter(function (element) {
        return window.getComputedStyle(element).display === "block";
      });
      if (elements.length === 0) {
        this.addComment(e);
      }
    }
  }

  pasteAsPlainText(e) {
    e.preventDefault();
    const text = e.clipboardData.getData("text/plain");
    document.execCommand("insertText", false, text);
  }

  updateMentions() {
    let updatedMentions = [];
    let mentions = document
      .getElementById("comment-content-editable")
      .querySelectorAll(".user-mention");
    if (mentions.length) {
      mentions.forEach(function (item) {
        updatedMentions = [
          ...updatedMentions,
          {
            id: parseInt(item.getAttribute("data-uid")),
            text: item.innerText,
          },
        ];
      });

      this.setState({
        mentioned: updatedMentions,
      });
    } else {
      this.setState({
        mentioned: [],
      });
    }
  }

  onUserChange(e, data) {
    let userSelectedName = "";

    if (typeof data.options !== "undefined" && data.options.length > 0) {
      data.options.map(function (item) {
        if (item.value === data.value) {
          userSelectedName = item.text;
        }
      });

      if (typeof this.props.onCommentFilterUserChange === "function") {
        this.props.onCommentFilterUserChange(data.value);
      }

      this.setState({
        userSelected: data.value,
        userSelectedName,
      });
    }
  }

  onSearchChange(e) {
    e.persist();

    if (typeof this.props.onCommentFilterSearchChange === "function") {
      this.props.onCommentFilterSearchChange(e.target.value);
    }
  }

  commentChange() {
    let self = this;
    this.setState(
      {
        commentValue: document.getElementById("comment-content-editable")
          .innerHTML,
      },
      self.updateMentions
    );
  }

  getActiveUsers() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let self = this;
    Flagship.get(
      "users/all",
      {},
      function (response) {
        let nameIndex = "line_item_name";
        let keyIndex = "line_item_key";
        let lineItems = Array.isArray(self.props.lineItems)
          ? self.props.lineItems
          : [];
        if (self.props.recordType === "io") {
          nameIndex = "io_product_name";
          keyIndex = "io_product_key";
        }

        self.tribute = new Tribute({
          collection: [
            {
              trigger: "@",
              values: response.data,
              allowSpaces: true,
              selectTemplate: function (data) {
                let mentionName = data.string.replace(/<[^>]+>/g, "");
                return (
                  `
                  <span contenteditable="false" class="user-mention-wrap"><span class="user-mention" data-uid="` +
                  data.original.id +
                  `" contenteditable="false">@` +
                  mentionName +
                  `</span></span>`
                );
              },
            },
            {
              trigger: "#",
              values: lineItems.map(function (l) {
                l.key = l[nameIndex] + " " + l[keyIndex];
                return l;
              }),
              allowSpaces: true,
              menuItemTemplate: function (item) {
                item.string =
                  item.original[nameIndex] +
                  " (#" +
                  item.original[keyIndex] +
                  ")";
                return (
                  item.original[nameIndex] +
                  "<span class='line-item-mention-key'> (#" +
                  item.original[keyIndex] +
                  ")</span>"
                );
              },
              selectTemplate: function (item) {
                return (
                  `
                  <span contenteditable="false" class="line-item-mention-wrap">
                  <a href="/` +
                  self.props.recordType +
                  "/view/" +
                  self.props.recordKey +
                  `/focus/` +
                  item.original[keyIndex] +
                  `"
                      class="line-item-mention focus-line-item" data-key="` +
                  item.original[keyIndex] +
                  `"
                      contenteditable="false">` +
                  item.original[nameIndex] +
                  `<span class="key focus-line-item"> (#` +
                  item.original[keyIndex] +
                  `)</span></a></span>`
                );
              },
            },
          ],
        });

        self.tribute.attach(
          document.getElementById("comment-content-editable")
        );
        document
          .getElementById("comment-content-editable")
          .addEventListener("tribute-replaced", function () {
            self.commentChange();
          });

        document.addEventListener("click", function (e) {
          if (e.target && e.target.classList.contains("focus-line-item")) {
            e.preventDefault();
            browserHistory.push(e.target.getAttribute("href"));
            return false;
          }
        });

        document.addEventListener("click", function (e) {
          if (e.target && e.target.classList.contains("tribute-clickable")) {
            self.tribute.showMenuForCollection(
              document.getElementById("comment-content-editable"),
              e.target.innerText === "#" ? 1 : 0
            );
            return false;
          }
        });
      },
      function (err) {
        Flagship.error(
          "Error getting comments from Flagship API server: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  getComments() {
    let self = this;
    Flagship.get(
      "comments/" + this.props.recordId,
      {},
      function (response) {
        if (response.data.success === true) {
          self.setState(
            {
              comments: response.data.results,
              loading: false,
            },
            function () {
              if (self.props.accessLevel === 2) {
                self.getActiveUsers();
              }
            }
          );
        } else {
          Flagship.error(
            "Error getting comments from Flagship API server.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function (err) {
        Flagship.error(
          "Error getting comments from Flagship API server: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  resetCommentBox() {
    this.getComments();
    this.setState({
      commentValue: "",
      mentioned: [],
    });
  }

  addComment() {
    if (this.props.accessLevel !== 2) {
      return;
    }

    // Sanitize comment to use placeholders for user mentions



    let comment = stripHTML(
      this.state.commentValue
        .replace(/\n/gim, "")
        .replace(/<\/div><br><div>/gim, "\n")
        .replace(/<br>/gim, "\n")
        .replace(/<\/div><div>/gim, "\n")
        .replace(/<div>/gim, "\n")
        .replace(/<\/div>/gim, "")
        .replace(
          /<span.*?class="user-mention".*?data-uid="\d+".*?>@([a-zA-Z0-9_'\s]+)<\/span>/gim,
          "{@mention $1} "
        )
        .replace(
          /<a href="([a-z 0-9\/\-\_\?]*)" class="line-item-mention focus-line-item" data-key="[a-z 0-9\-]+" contenteditable="false">([a-z 0-9\-]*)[\s,\S]*?<span class="key focus-line-item"> ?\(([a-z0-9 #\-]*)\)[\s,\S]*?<\/span><\/a>/gim,
          "{#mention $3 $1 $2} "
        )
    )
      .replace(/ +([,:;])/g, "$1")
      .replace(/\t/g, " ")
      .replace(/ +(?= )/g, "");

    let recordId = this.props.recordId;
    let userId = this.props.userId;
    let resetCommentBox = this.resetCommentBox;
    let mentioned = this.state.mentioned;

    if (comment !== null && comment !== "") {
      Flagship.post(
        "comments/new/" + recordId + "/" + userId,
        {
          comment,
          mentioned,
        },
        function (response) {
          if (response.data.success === true) {
            Flagship.event(
              "comment",
              {
                comment,
                mentioned,
              },
              recordId,
              userId
            );
            Flagship.notify("Comment added.", "success");
            resetCommentBox();
          } else {
            Flagship.log("error", "Failed to add comment.", recordId, userId);
          }
        }
      );
    } else {
      Flagship.notify("Comment box empty.", "info");
    }
  }

  deleteComment(commentId) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    let getComments = this.getComments;
    let recordId = this.props.recordId;
    let userId = this.props.userId;

    Flagship.post("comments/delete/" + commentId, {}, function (response) {
      if (response.data.success === true) {
        Flagship.notify("Comment deleted.");
        getComments();
      } else {
        Flagship.log("error", "Failed to delete comment.", recordId, userId);
      }
    });
  }

  highlightSearch(val) {
    if (typeof this.props.commentFilterSearch === "string" &&
      this.props.commentFilterSearch.length > 1) {
      val = val.replace(
        new RegExp(this.props.commentFilterSearch, "gi"),
        (match) => {
          return `%%search%%${match}%%!search%%`;
        }
      );
    }
    return val;
  }

  render() {
    if (
      typeof this.state.comments === "undefined" ||
      this.state.loading === true
    ) {
      return (
        <Table>
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="5">
                <Loader className="flagship-loader" active inline="centered">
                  Loading Comments...
                </Loader>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    } else {
      let self = this;
      let commentsShown = this.state.commentsShown;
      let moreComments = this.state.comments.length - this.state.commentsShown;
      let numberComments = this.state.comments.length;
      let deleteComment = this.deleteComment.bind(this);
      let currentUser = this.props.userId;
      let timezone = getTimezone(this.props.userMarket);
      let widgetTitle =
        this.props.viewMode === "full" ? "All Comments" : "Recent Comments";

      let filtersActive = false;

      if (this.props.commentFilterUser || this.props.commentFilterSearch) {
        widgetTitle = "Filtered Comments";
        filtersActive = true;
      }

      if (this.props.search === true) {
        return (
          <div className="record-comments search-mode">
            <Header as="h3">Search Comments...</Header>
            <Input
              fluid
              placeholder="Search..."
              ref={(input) => (this.inputRef = input)}
              onKeyUp={(e, data) => self.onSearchChange(e, data)}
            />
            <Divider hidden />
            <strong>Filter by person...</strong>
            <UserField
              fluid
              placeholder="Search People...."
              userData={null}
              onChange={(e, data) => self.onUserChange(e, data)}
              preventFocus={true}
              allowDelete={true}
              onReset={() => {
                this.props.onCommentFilterUserChange(false);
              }}
            />
            <Divider hidden />
            <Divider hidden />
            {this.props.accessLevel === 2 ? (
              <Button
                icon
                primary
                onClick={() => {
                  document
                    .getElementById("beneath-comment-form")
                    .scrollIntoView(false);

                  document.getElementById("comment-content-editable").focus();
                }}
              >
                Add a Comment...
              </Button>
            ) : null}
          </div>
        );
      }

      let filteredCount = 0;

      return (
        <div className="record-comments">
          {this.props.viewMode === "full" ? (
            <Button
              icon
              className="comment-view-most-recent"
              floated="right"
              onClick={() => {
                const commentForm = document.getElementById(
                  "comment-add-comment-form"
                );
                const commentBottom = document.getElementById(
                  "beneath-comment-form"
                );

                (commentForm || commentBottom).scrollIntoView(false);

                if (this.props.accessLevel === 2) {
                  document.getElementById("comment-content-editable").focus();
                }
              }}
            >
              <Icon name="chevron down" />
              View Most Recent
            </Button>
          ) : (
            <Button
              icon
              className="comment-view-all"
              floated="right"
              onClick={this.props.viewMoreComments}
            >
              <Icon name="chevron left" />
              View All
            </Button>
          )}
          <Header as="h3" style={{ marginTop: "18px" }}>
            {widgetTitle}
          </Header>

          {moreComments > 0 ? (
            <Divider color="gray" horizontal style={{ clear: "both" }}>
              <Label
                onClick={this.props.viewMoreComments}
                className="pointer earlier-comments"
                title="Click to view more"
              >
                <Icon name="comment" />
                {moreComments}
                <Label.Detail>Earlier Comment(s)</Label.Detail>
              </Label>
            </Divider>
          ) : (
            <Divider />
          )}
          <Feed>
            {numberComments > 0
              ? this.state.comments.map(function (comment, i) {
                  let isCurrentUser = parseInt(comment.user) === currentUser;
                  let commentId = parseInt(comment.id);
                  let photoPath = "someone.png";
                  if (comment.photo !== null) {
                    photoPath = comment.photo;
                  }
                  let commenterName = "Someone";
                  if (
                    comment.first_name !== null &&
                    comment.last_name !== null
                  ) {
                    commenterName =
                      comment.first_name + " " + comment.last_name;
                  }

                  //Fix any character references we don't want to keep
                  comment.content = comment.content.toString();
                  comment.content = comment.content.replace(/&amp;/g, "&");
                  comment.content = comment.content.replace(/&nbsp;/g, " ");
                  comment.content = comment.content.replace(/\S<a/g, " <a");

                  if (
                    i > numberComments - commentsShown - 1 &&
                    (self.props.commentFilterUser === false ||
                      comment.user === self.props.commentFilterUser) &&
                    (self.props.commentFilterSearch === false ||
                      comment.content
                        .toLowerCase()
                        .includes(self.props.commentFilterSearch.toLowerCase()))
                  ) {
                    filteredCount++;

                    return (
                      <Feed.Event
                        key={"comment-" + i}
                        className="single-comment"
                      >
                        {isCurrentUser && self.props.accessLevel === 2 ? (
                          <Label
                            className="edit-corner-icon"
                            size="large"
                            corner="right"
                            rel={commentId}
                            onClick={() => {
                              deleteComment(commentId);
                            }}
                          >
                            <Icon
                              className="edit-corner-icon-icon"
                              name="trash"
                            />
                          </Label>
                        ) : null}
                        <Feed.Content>
                          <Feed.Summary>
                            <Feed.User>
                              <Image
                                className="comment-image"
                                size="tiny"
                                src={Flagship.config.uploads + photoPath}
                              />
                            </Feed.User>
                            <span>{commenterName}</span>
                            <Feed.Date>
                              {moment(comment.date, "YYYY-MM-DD hh:mm:ss")
                                .tz(timezone)
                                .format("MM/DD/YY LT z")}
                            </Feed.Date>
                          </Feed.Summary>
                          <Feed.Extra text className="comment-content">
                            <Linkify properties={{ target: "_blank" }}>
                              {getFormattedValue(
                                addMentions(
                                  self.highlightSearch(comment.content)
                                )
                              )}
                            </Linkify>
                          </Feed.Extra>
                        </Feed.Content>
                      </Feed.Event>
                    );
                  }
                })
              : "No comments to display."}
          </Feed>
          {filtersActive ? (
            <div className="filter-result-message">
              {filteredCount === 0 ? (
                <span className="gray-text">
                  <Icon name="filter" />
                  No comments matched your filter criteria.
                </span>
              ) : (
                <span className="gray-text">
                  <Icon name="filter" />
                  {filteredCount} comment{filteredCount !== 1 ? "s" : null}{" "}
                  matched your filter criteria.
                </span>
              )}
            </div>
          ) : null}
          {this.props.accessLevel === 2 ? (
            <Form id="comment-add-comment-form">
              {self.props.viewMode === "full" ? <h3>Leave a comment</h3> : null}
              <ContentEditable
                html={this.state.commentValue}
                onChange={this.commentChange}
                onPaste={this.pasteAsPlainText}
                onKeyDown={this.commentKeyDown}
                className="comment-textarea"
                id="comment-content-editable"
              />

              <Button
                key="comment-button"
                onClick={this.addComment}
                className="add-new-comment"
              >
                Add New Comment
              </Button>

              <span className="tribute-clickable">@</span>

              {this.props.recordType === "rfp" ||
              this.props.recordType === "io" ? (
                <span className="tribute-clickable">#</span>
              ) : null}
              <div className="comment-mentions" key="mentions">
                {this.state.mentioned.length ? (
                  <span className="mentioned">
                    {this.state.mentioned.map(function (item, i) {
                      return (
                        <UserCircle
                          key={"user-circle-" + i}
                          userId={item.id}
                          defaultImage="mention.png"
                          contentLabel={<em>Mentioned:</em>}
                        />
                      );
                    })}
                  </span>
                ) : null}
              </div>
            </Form>
          ) : null}
          <div id="beneath-comment-form"></div>
        </div>
      );
    }
  }
}

CommentBox.propTypes = {
  actions: PropTypes.object,
  username: PropTypes.string,
  userId: PropTypes.number,
};

CommentBox.defaultProps = {
  lineItems: [],
  commentFilterSearch: false,
  commentFilterUser: false,
};

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole,
    userMarket: state.main.userMarket,
    accessLevel: state.main.accessLevel,
  };
}

export default connect(mapStateToProps, null)(CommentBox);



// WEBPACK FOOTER //
// ./src/components/misc/CommentBox.js